/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Pelvic_Floor_Physio_TermsInputs */

const en_service_type_pelvic_floor_physio_terms = /** @type {(inputs: Service_Type_Pelvic_Floor_Physio_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pelvic floor, incontinence, women's health`)
};

const pl_service_type_pelvic_floor_physio_terms = /** @type {(inputs: Service_Type_Pelvic_Floor_Physio_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dno miednicy, nietrzymanie moczu, uroginekologia, mięśnie dna miednicy`)
};

/**
* | output |
* | --- |
* | "pelvic floor, incontinence, women's health" |
*
* @param {Service_Type_Pelvic_Floor_Physio_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_pelvic_floor_physio_terms = /** @type {((inputs?: Service_Type_Pelvic_Floor_Physio_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Pelvic_Floor_Physio_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_pelvic_floor_physio_terms(inputs)
	return en_service_type_pelvic_floor_physio_terms(inputs)
});